import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
// @ts-ignore
import appboy from 'appboy-web-sdk';
export var Braze = /*#__PURE__*/function () {
  function Braze(apiKey) {
    _classCallCheck(this, Braze);

    _defineProperty(this, "appboy", void 0);

    _defineProperty(this, "apiKey", void 0);

    _defineProperty(this, "messages", void 0);

    this.apiKey = apiKey;
    this.messages = [];
  }

  _createClass(Braze, [{
    key: "initialize",
    value: function initialize(uuid) {
      var _this = this;

      if (navigator.userAgent.includes('jsdom')) {
        return;
      } else if (!this.appboy) {
        this.appboy = appboy;
        this.appboy.initialize(this.apiKey, {
          minimumIntervalBetweenTriggerActionsInSeconds: 0,
          doNotLoadFontAwesome: true
        });
      }

      this.appboy.changeUser(uuid);
      this.appboy.subscribeToNewInAppMessages(function (inAppMessages) {
        _this.messages.push(inAppMessages.pop());

        return inAppMessages;
      });
      this.appboy.openSession();
    }
  }, {
    key: "showMessage",
    value: function showMessage() {
      if (this.messages.length) {
        this.appboy.display.showInAppMessage(this.messages.pop());
      }
    }
  }]);

  return Braze;
}();
export var createBrazeClient = function createBrazeClient(apiKey) {
  return new Braze(apiKey);
};